export default function numberSpaces( number ) {

  return number.toString().replace(/(?!^)(\d{3})(?=(\d{3})*$)/g, " $1");

}